var triggerTabList = [].slice.call(document.querySelectorAll('.video-showcase a[data-bs-toggle="tab"]'))
triggerTabList.forEach(function (triggerEl) {
  triggerEl.addEventListener('shown.bs.tab', function (event) {
    var prevTarget = document.querySelector(event.relatedTarget.dataset.bsTarget);
    var prevVideo = prevTarget.querySelector('iframe');
    var prevVideoSrc = prevVideo.getAttribute('src');
    prevVideo.setAttribute("src", "");
    prevVideo.setAttribute("src", prevVideoSrc);
    // prevVideo.pause();
  })
})